"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconUpgradesAndRefurbishment = function IconUpgradesAndRefurbishment(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 21.015V5H10v20.58l-.005.258c-.076 1.923-.977 4.542-2.438 7.442l1.786.9.213-.427C11.086 30.633 12 27.814 12 25.58V10.92h13.77v-1H12V7h19v13.811l-.128-.002A11.063 11.063 0 0 0 19.76 31.914 11.1 11.1 0 0 0 20.989 37H8v2h14.308A11.11 11.11 0 1 0 33 21.015M44 24V12h-9v2h7v10zM22 41v2H12v-2zm8.87-18.19a9.11 9.11 0 1 1-9.11 9.1 9.063 9.063 0 0 1 9.11-9.1M32 33v4h-2v-4h-4v-2h4v-4h2v4h4v2z",
    clipRule: "evenodd"
  })));
};

export { IconUpgradesAndRefurbishment, IconUpgradesAndRefurbishment as default };
